import { cache } from "../constants/pwa";
import i18next from "i18next";

export const isPwaInstalled = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};

export const pwaInstall = async (setIsInstall?: () => void) => {
  if (!cache["root"]) return;
  if (isPwaInstalled()) {
    alert(i18next.t("Download_App is installed"));
    return;
  }
  await cache["root"].prompt();
  cache["root"]?.userChoice.then(
    (choiceResult: { outcome: "accepted" | "dismissed" }) => {
      if (choiceResult.outcome === "accepted") {
        setIsInstall?.();
      }
    },
  );
};
